import {TableModelContext} from 'notebook/tables/store/contexts/TableModelContext';
import {TableEditableStableProps, TableEditableVolatileProps} from 'notebook/tables/store/TableStore';

/**
 * Subscribes to the table's stable props, or to a value selected from them. The props are
 * shallow-memoized when written, so the whole object keeps its reference until a prop changes.
 */
export function useTableProps(): TableEditableStableProps;
export function useTableProps<T>(selector: (props: TableEditableStableProps) => T): T;
export function useTableProps<T>(selector?: (props: TableEditableStableProps) => T): T {
  const {useTableEditableStore} = TableModelContext.useContext();
  return useTableEditableStore((store) =>
    selector ? selector(store.stableProps) : (store.stableProps as T)
  );
}

/**
 * Subscribes to the table's volatile props (`table`, `computedTable`, row status arrays), or to a
 * value selected from them. These change on every table edit; prefer a value from the table model,
 * and remove these reads as they move into it.
 */
export function useTableVolatileProps(): TableEditableVolatileProps;
export function useTableVolatileProps<T>(selector: (props: TableEditableVolatileProps) => T): T;
export function useTableVolatileProps<T>(selector?: (props: TableEditableVolatileProps) => T): T {
  const {useTableEditableStore} = TableModelContext.useContext();
  return useTableEditableStore((store) =>
    selector ? selector(store.volatileProps) : (store.volatileProps as T)
  );
}
